<div class="hpanel search-page-navbar-stickyyy gs-card">
  <div class="panel-body border-radius-top-left-right-6 gs-card-body">
    <div class="mainNav">
      <!-- Result count, matching the Business and People listing headers. This tab
           lists people and businesses together, so the label follows the menu name
           and the number is the two totals added. It is the whole result set, not
           the cards loaded so far, so it does not climb as the page scrolls. -->
      <div class="navIteam">
        <h6>All : <span> {{allTotalCount}}</span></h6>
      </div>
      <div class="navIteam pos-rel-10">
        <!-- <div class="input-group f-l"> -->
          <input type="text" class="form-control pd-lt-10 search-field-pad" (keyup)="searchData($event)" [formControl]="clearInput"
            name="searchadmin" id="searchadmin" placeholder="Search people and business"/>
          <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>
          <!-- <span class="input-group-addon"><ng-icon name="tablerSearch"></ng-icon></span>
          <span class="input-group-addon" (click)="clearData()"><ng-icon name="tablerX"></ng-icon></span> -->
        <!-- </div> -->
      </div>
      <!-- <div class="navIteam connectionbtn"> -->
        <!-- <div class="btn-group" dropdown> -->
          <!-- <button id="button-animated" dropdownToggle type="button" class="btn dropdown-toggle fbtn"
            aria-controls="dropdown-animated">
            <span class="mr-5"><img src="assets/icon/icons8-mail-filter-96.png" alt="" srcset=""
                class="filimg" /></span>Filter
          </button> -->
          <!-- <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu"
              role="menu" aria-labelledby="button-animated">
              <li role="menuitem"><a class="dropdown-item" (click)="apicall('CONNECTED')">All Connection</a></li>
            <li role="menuitem"><a class="dropdown-item" (click)="apicall('Invitation_Received')">Request Received</a></li>
            <li role="menuitem"><a class="dropdown-item" (click)="apicall('Invitation_Sent')">Invitations Sent </a></li>
          </ul> -->
        <!-- </div> -->
      <!-- </div> -->
      <div class="navIteam">
        <button class="btn primary-btn">Advance Search</button>
      </div>
    </div>
  </div>
</div>
<div class="search-content-layout">
  <!-- infiniteScroll sits on the feed itself: it is the flex grid, so the
       cards must stay its direct children (a wrapper div collapses the grid). -->
  <div class="search-content-feed" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
    [scrollWindow]="true" (scrolled)="onScroll()">
    <!-- Skeleton grid while the results fetch is in flight -->
    <ng-container *ngIf="isLoading">
      <div class="col-md-4 sCard" *ngFor="let c of loaderCards">
        <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading">
      <div class="col-md-4 sCard" *ngFor="let item of users">
        <app-user-card [userDataInput]="item" [standard]="true"> </app-user-card>
      </div>
      <div class="col-md-4 sCard slkpp" *ngFor="let item of businessPages ">
        <app-business-card [BusinessDataInput]="item"></app-business-card>
      </div>
      <div class="col-md-4 sCard" *ngFor="let item of CommunityData ">
        <app-community-card [data]="item"></app-community-card>
      </div>
      <!-- Next page in flight -->
      <ng-container *ngIf="isLoadingMore">
        <div class="col-md-4 sCard" *ngFor="let c of loadMoreCards">
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
      </ng-container>
      <!-- Search came back with nothing on EITHER list. Uses the same
           app-nodata-found empty state as the rest of the app (connections, team
           members, community members) so People / Business / All all read
           identically instead of leaving a blank panel under the result count. -->
      <div class="col-sm-12"
        *ngIf="users.length === 0 && businessPages.length === 0 && !CommunityData?.length && !isLoadingMore">
        <app-nodata-found screen="SEARCH" [title]="['No results found']" [buttonShow]="false">
        </app-nodata-found>
      </div>
      <div class="col-sm-12" *ngIf="!hasMore && !isLoadingMore && (users.length > 0 || businessPages.length > 0)"
        style="text-align: center; padding: 1.5rem 0; color: #777;">
        <ng-icon name="tablerCircleCheck"></ng-icon>
        <p class="biase">You've reached the bottom of the page</p>
      </div>
    </ng-container>
  </div>
  <div class="search-content-widget search-page-mr-tp-10">
    <app-common-widget [page]="'NETWORK_PAGE'" [inputData]="'NETWORK'"></app-common-widget>
  </div>
</div>